import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./index.scss";

const QuantityInput = ({ quantite = 1, setError, onChange, disabled }) => {
  const [quantity, setQuantity] = useState(1);

  // notifier le parent dès le montage
  useEffect(() => {
    if (onChange) onChange(quantity);
  }, []);

  const increase = () => {
    if (quantity < quantite) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      setError("");
      if (onChange) onChange(newQuantity);
    } else {
      setError(`La quantité maximale disponible est ${quantite}`);
    }
  };

  const decrease = () => {
    if (quantity > 1) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      setError("");
      if (onChange) onChange(newQuantity);
    }
  };

  return (
    <div className="quantity-input">
      <Button
        variant="light"
        className="btn-quantity"
        onClick={decrease}
        disabled={disabled}>
        –
      </Button>
      <span className="value">{quantity}</span>
      <Button
        variant="light"
        className="btn-quantity"
        onClick={increase}
        disabled={disabled}>
        +
      </Button>
    </div>
  );
};

export default QuantityInput;
